import StyledLink from '../StyledLink'
import {
  DUPLICATE,
  MONITOR,
  MONITOR_CONFIG
} from '../routes'
import type { Props } from '../types'

interface Params {
  testConfigId: string
}

const LinkToDuplicateMonitorConfig = ({
  children,
  testConfigId,
  openInNewTab,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    openInNewTab={openInNewTab}
    to={`/${MONITOR}/${MONITOR_CONFIG}/${testConfigId}/${DUPLICATE}`}
  >
    {children}
  </StyledLink>

export default LinkToDuplicateMonitorConfig
